import type { SelectableEvidenceRow } from "@cle/models/selectableEvidenceRow";

/**
 * Generisk over kategorinøglen: efteruddannelsesflowet har seks kategorier (inkl. dispensationer),
 * påbuds-/pålægsflowet har fem. Tidligere var den låst til efteruddannelsesnøglerne, så
 * påbudskaldet ikke kunne typechecke.
 */
export const groupEvidenceItemIdsByCategory = <K extends string>(
  evidenceItemIds: string[],
  documentsByCategory: Record<K, SelectableEvidenceRow[]>,
): Record<K, string[]> => {
  const idSet = new Set(evidenceItemIds);

  return (
    Object.entries(documentsByCategory) as [K, SelectableEvidenceRow[]][]
  ).reduce(
    (grouped, [categoryKey, documents]) => {
      return {
        ...grouped,
        [categoryKey]: documents
          .filter(
            (document) =>
              idSet.has(document.id) || idSet.has(document.evidenceItemId),
          )
          .map((document) => document.id),
      };
    },
    {} as Record<K, string[]>,
  );
};
